import { getEnv, IStateTreeNode } from 'mobx-state-tree'

import { ProcessableGameEventComamnd } from '@ppwr/sdk'

import { RootStore } from '../root.store'
import { RootStoreEnv } from '../RootStoreEnv'
import { useSessionStore } from '../session/useSessionStore'

/**
 * Adds a putCommand property to the node for a convenient
 * and strongly typed way for stores to access other stores.
 */
export const withKinesisGameEventCommands = (self: IStateTreeNode) => ({
  actions: {
    /**
     * Abstract post for fetch.
     */
    async putCommand({ root, command }: { root: RootStore; command: ProcessableGameEventComamnd }) {
      const env = getEnv<RootStoreEnv>(root)
      const accessToken = useSessionStore.getState().getAccessToken()
      await fetch(env.kinesisGameEventCommandsUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify(command)
      })
        .then((response) => response.json())
        .then((json) => {
          return json.movies
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
})
